import { render, staticRenderFns } from "./batch-list.vue?vue&type=template&id=21ba11a6"
import script from "./batch-list.vue?vue&type=script&lang=js"
export * from "./batch-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports